import React, { useMemo } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { Box, Button, Card, Stack, Typography } from "@mui/material";
import { BsDashLg } from "react-icons/bs";
import { overviewChartPalette } from "styles/theme";


const LegendItem = ({ color, label }) => (
    <Stack direction="row" spacing={1} alignItems="center">
        <Box
            sx={{
                width: '20px',
                height: '3px',
                borderRadius: 999,
                bgcolor: color,
            }}
        />
        <Typography
            variant="body1"
            sx={{
                fontSize: '12px',
                fontWeight: 500,
                color: "#7D7F81",
                letterSpacing: '1%',
                fontFamily: "Outfit, sans-serif",
            }}
        >
            {label}
        </Typography>
    </Stack>
);

const InvoicesAgingBucket = () => {
    const categories = ["0-30 days", "31-60 days", "61+ days"];
    const data = [30, 110, 45];

    const options = {
        chart: {
            type: "column",
            height: 360,
            spacingBottom: 40,
        },
        title: { text: "" },
        credits: { enabled: false },
        legend: { enabled: false },

        xAxis: {
            categories,
            lineColor: "#e5e7eb",
            tickColor: "transparent",
            labels: {
                style: {
                    fontSize: "14px",
                    color: "#333436",
                    fontWeight: 500,
                    fontFamily: "Outfit, sans-serif",
                },
            },
        },

        yAxis: {
            min: 0,
            title: { text: "" },
            gridLineColor: "#e5e7eb",
            labels: {
                style: {
                    fontSize: "14px",
                    color: "#333436",
                    fontWeight: 500,
                    fontFamily: "Outfit, sans-serif",
                },
                formatter: function () {
                    // add thin space grouping to look like 25 000
                    return this.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
                },
            },
        },

        tooltip: {
            enabled: true,
            valueSuffix: "",
        },

        plotOptions: {
            column: {
                borderRadius: 6,
                borderWidth: 0,
                pointPadding: 0.2,
                color: overviewChartPalette.violet,
                dataLabels: {
                    enabled: true,
                    style: {
                        color: "#4b5563",
                        textOutline: "none",
                        fontWeight: 500,
                        fontSize: "12px",
                    },
                    formatter: function () {
                        return this.y.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
                    },
                },
            },
        },

        series: [
            {
                name: "Amount",
                data,
            },
        ],
    };

    return (
        <Card
            elevation={0}
            sx={{
                borderRadius: 3,
                border: "1px solid #E4E4E4",
                width: '100%',
            }}
        >
            <Box sx={{
                width: '100%',
                borderBottom: "1px solid #E4E4E4",
                p: 1.5,
                display: 'flex',
                justifyContent: 'space-between'
            }}>
                <Box>
                    <Typography variant="subtitle1" sx={{
                        fontFamily: "Outfit, sans-serif",
                        fontWeight: 600,
                        fontSize: '20px',
                        letterSpacing: "0px",
                        mb: 0
                    }}>
                        Invoice Ageing
                    </Typography>
                    <Typography variant="body2" sx={{
                        fontFamily: "Outfit, sans-serif",
                        fontWeight: 300,
                        fontSize: '16px',
                        letterSpacing: "0px",
                        color: '#7D7F81'
                    }}>
                        Identify overdue invoice value by ageing period for collection follow-up.
                    </Typography>
                </Box>
            </Box>
            <Box sx={{
                width: '100%',
                pt: 2
            }}>
                <HighchartsReact highcharts={Highcharts} options={options} />
            </Box>
        </Card>
    );
};

export default InvoicesAgingBucket;
